import type { CSSProperties } from 'react';
import styled from 'styled-components';
import colors from '../../../../utils/colors';

export const Title = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 16px;
	color: ${colors.blGrayscale300};

	h6 {
		color: ${colors.blGrayscale300};
		margin: 0 4px 0 8px;
	}
`;

export const TitleContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	
`;

export const LoadingMyBackgrounds = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 140px;
	width: 100%;
`;

export const Shadow = styled.div`
	/* shadow */

	position: absolute;
	height: 32px;
	left: 0px;
	right: 0px;
	top: -32px;

	background: linear-gradient(180deg, rgba(38, 36, 43, 0) 0%, ${colors.blGrayscale900} 100%);

	/* Inside auto layout */
	flex: none;
	order: 5;
	flex-grow: 0;
	z-index: 5;
`;

export const ClearButtonContainer = styled.div`
	padding: 16px 0 16px 16px;
	position: absolute;
	bottom: 0;
	left: 0;
	width: calc(100% - 16px);
	height: 72px;
	background: ${colors.blGrayscale900};
`;

export const ClearButton = styled.div`
	background: none;
	cursor: pointer;
	color: ${colors.blGrayscale400};
	display: flex;
	align-items: center;
	margin-bottom: 16px;
	opacity: 0;
	cursor: default;

	transition: 0.1s all ease-out;
	&.shown {
		opacity: 1;
		cursor: pointer;
	}

	&:hover {
		filter: brightness(110%);
	}

	&:active {
		filter: brightness(90%);
	}
`;

export const CardContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	transition: 0.3s all ease-out;
	max-height: 195px; // 3 cards and 12px x 3 gaps
	overflow: hidden;
	position: relative;
`;

export const SelectedOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0);
	border-radius: 8px;
	box-sizing: border-box;
	pointer-events: none;
	display: inline-block;
	border: 2px solid ${colors.paleGreen};
`;

export const EllipsesContainer = styled.div`
	position: absolute;
	top: 4px;
	right: 8px;
	cursor: pointer;
	padding: 0 0 0 8px;
	border-radius: 80px;
`;

export const UnstyledUl = styled.ul`
	background-color: ${colors.blGrayscale800};
	border-radius: 0 0 8px 8px;
	list-style-type: none;
	padding: 0;
	margin: 0;
`;

export const BlurCardLabel = styled.h6`
	//text-shadow: 0px 1px 3px 1px #00000026, box-shadow: 0px 1px 2px 0px #0000004D;
	text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3), 1px -1px 3px rgba(0, 0, 0, 0.5);
	
	background-color: rgba(1, 1, 1, 0.2);
	border-radius: 8px;
	margin: 0;
`;

export const Card = styled.div`
	background-color: black;
	border-radius: 8px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	overflow: visible;
	position: relative;
	box-sizing: border-box;
	box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
	flex-basis: 30.33%;
	aspect-ratio: 16/9;
	max-height: 57px;
	
	transition: 0.3s all ease-out;

	.popover-parent {
		display: none;
	}

	&:hover {
		.popover-parent {
			display: flex;
		}

		img {
			filter: brightness(80%);
		}
	}

	&:active {
		transform: scale(0.99);
		box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
		img {
			filter: brightness(100%);
		}
	}

	&.add-card {
		background-color: ${colors.blGrayscale1000};
		&:hover {
			background-color: ${colors.blGrayscale1100};
		}
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: fill;
		border-radius: 8px;
		transition: 0.3s all ease-out;
	}

	.add-text {
		/* Gradient/Sunset */
		background: linear-gradient(90deg, #FFFD62 0%, #FF6AE6 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		text-fill-color: transparent;
	}
`;

export const BigGradientButton = styled.div`
	background: linear-gradient(108.66deg, #FF6AE6 -4.67%, #FFF85C 69.07%, #A6FF79 120.95%);
	padding: 12px 20px;
	margin-top: 12px;
	border-radius: 88px;
	cursor: pointer;
	display: flex;
	align-items: center;
`;

export const NoVideoTelly = styled.img`
	position: absolute;
	right: 0;
	bottom: 0;
	z-index: 0;
`;

export const FullWidthStyle: CSSProperties = {
	width: '100%',
	aspectRatio: '16/9',
	borderRadius: '12px',
	marginBottom: '2px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flexDirection: 'column',
	position: 'relative',
	overflow: 'hidden',
	backgroundColor: `${colors.blGrayscale1200}`,
};
